<template>
  <span class="us-signin-icon" :class="'us-signin-icon--' + (method || 'Application').toLowerCase()">
    <font-awesome-icon v-if="method === 'Microsoft'" :icon="['fab', 'microsoft']"/>
    <font-awesome-icon v-else-if="method === 'Google'" :icon="['fab', 'google']"/>
    <font-awesome-icon v-else icon="key"/>
  </span>
</template>

<script>
  export default {
    name: 'SignInMethodIcon',
    props: {
      method: String
    }
  }
</script>
